import { render, staticRenderFns } from "./voice.vue?vue&type=template&id=0c8a7660&scoped=true"
import script from "./voice.vue?vue&type=script&lang=js"
export * from "./voice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8a7660",
  null
  
)

export default component.exports